import { createFileRoute } from "@tanstack/react-router";
import { ReportSchedulesPage } from "@/features/report-schedules/report-schedules-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/harmonogramy-raportow")({
	component: ReportSchedulesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.system.harmonogramy-raportow",
			location.pathname,
		);
	},
});
